import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Marker, Popup } from 'react-leaflet';
import Leaflet from 'leaflet';
import GoogleMapsLoader from 'google-maps';
import { getIconByMapLayer } from '../../../utils/getPropertyIcon';
import { activateMapLoadingStatus, deactivateMapLoadingStatus } from '../../../store/actions';

const layers = [
  {
    name: 'Hospitals',
    storeIconName: 'Hospital',
    defaultIcon: 'share/marker-hospital.png',
    googleType: 'hospital',
  },
  {
    name: 'Universities',
    storeIconName: 'Post Secondary School',
    defaultIcon: 'share/marker-college.png',
    googleType: 'university',
  },
  {
    name: 'Airports',
    storeIconName: 'Airport',
    defaultIcon: 'share/marker-airport.png',
    googleType: 'airport',
  },
];

class PredefinedLayer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { locations: [] };
  }

  componentWillMount() {
    this.setIcon();
    this.updateLocations();
  }

  setIcon() {
    const { markers, layer } = this.props;
    const { storeIconName, defaultIcon } = layers.find(l => l.name === layer);

    this.icon = getIconByMapLayer(storeIconName, defaultIcon, markers);
  }

  componentWillUnMount() {
    this.props.stopLoading();
  }

  updateLocations() {
    // Bounds will ideally be passed in as the bounding box around a "profile" to limit search area
    // However, if an org doesn't have a profile of any sort, default to the entire visible map area
    const { bounds = this.context.map.getBounds() } = this.props;

    this.setState({ locations: [] });

    this.props.startLoading();
    GoogleMapsLoader.load(google => {
      const { googleType } = layers.find(l => l.name === this.props.layer);

      const service = new google.maps.places.PlacesService(document.createElement('div'));
      service.textSearch({
        bounds: new google.maps.LatLngBounds(
          new google.maps.LatLng(bounds._southWest.lat, bounds._southWest.lng),
          new google.maps.LatLng(bounds._northEast.lat, bounds._northEast.lng),
        ),
        query: googleType,
        type: googleType,
      }, this.processResults.bind(this));
    });
  }

  processResults(results, status, pagination) {
    this.props.startLoading();
    if (status === google.maps.places.PlacesServiceStatus.OK && results.length > 0) {
      this.setState({
        locations: [
          ...this.state.locations,
          ...results.map(result => ({
            latitude: result.geometry.location.lat(),
            longitude: result.geometry.location.lng(),
            name: result.name,
            address: result.formatted_address,
          })),
        ],
      });
    }

    if (pagination.hasNextPage) {
      pagination.nextPage();
    } else {
      this.props.stopLoading();
    }
  }

  render() {
    return (
      <div>
        {this.state.locations.map((location, index) =>
          <Marker
            key={`${location.name}-${index}`}
            icon={Leaflet.icon({ iconUrl: this.icon })}
            position={[
              parseFloat(location.latitude),
              parseFloat(location.longitude),
            ]}
          >
            <Popup className="leaflet-business-popup">
              <div className="business-popup">
                <b>{location.name}</b>
                <p>{location.address}</p>
              </div>
            </Popup>
          </Marker>,
        )}
      </div>
    );
  }
}

PredefinedLayer.propTypes = {
  layer: PropTypes.string.isRequired,
  bounds: PropTypes.object,
  markers: PropTypes.object,
  startLoading: PropTypes.func,
  stopLoading: PropTypes.func,
};

PredefinedLayer.contextTypes = {
  map: PropTypes.object,
};

const mapDispatchToProps = dispatch => ({
  startLoading: () => dispatch(activateMapLoadingStatus()),
  stopLoading: () => dispatch(deactivateMapLoadingStatus()),
});

export default connect(null, mapDispatchToProps)(PredefinedLayer);



// WEBPACK FOOTER //
// ./src/components/Map/Layers/Predefined.js